import { BsShare } from 'dida-web-common'

export default (shareConfig = {}) => {
    if (shareConfig.switch) {
        // title, desc, link, imgUrl, success, fail, cancel, wx_appid, jsApiList, openTagList
        // title, desc, link, imgUrl, success, fail, cancel, wx_appid, jsApiList, openTagList
        const obj = {
            data: {
                title: shareConfig.title,
                desc: shareConfig.desc,
                imgUrl: shareConfig.imgUrl,
                link: shareConfig.url || window.location.href
                // showChannel: shareConfig.showChannel
            },
            shareByApp: {
                enable: shareConfig.appShareSwitch
                // channel:
            },
            shareByMinipg: {
                enable: true,
                link: '/pagesWebView/webViewActivity/webViewActivity?baseUrl=' + encodeURIComponent(shareConfig.url || window.location.href),
                imgUrl: shareConfig.imgUrl
            },
            shareByWx: {
                enable: true
            },
            shareByDingtalk: {
                enable: true
            }
        }
        if (shareConfig.appShareSwitch && shareConfig.showChannel) {
            obj.data.showChannel = shareConfig.showChannel
        }
        // if (!shareConfig.appShareSwitch) {
        //     obj.shareByApp.enable = false
        // }
        new BsShare(obj)
    }
}
